var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "7f2b51df4ddc0bd0dec541dfce81e95cdf8c181a"
};